<template>
  <div class="popup-overlay" :style="overlayStyle" @click="$emit('close')">
    <div class="popup-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    overlayStyle: {
      type: Object,
      default: () => ({
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--app-width);
  height: var(--app-height);
  z-index: var(--z-index-screen-popup);

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>